import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { CreditCard } from 'angular-cc-library';

@Component({
  selector: 'cc-indicators',
  template: `
    <div>
      <img
        *ngIf="!displayType || displayType == 'visa'"
        src="https://static.idonate.com/images/visa.svg"
      />
      <img
        *ngIf="!displayType || displayType == 'discover'"
        src="https://static.idonate.com/images/discover.svg"
      />
      <img
        *ngIf="!displayType || displayType == 'amex'"
        src="https://static.idonate.com/images/amex.svg"
      />
      <img
        *ngIf="!displayType || displayType == 'mastercard' || displayType == 'master'"
        src="https://static.idonate.com/images/master.svg"
      />
    </div>
  `
})
export class CcIndicatorsComponent implements OnInit, OnChanges {
  @Input() number;
  @Input() type; // Optional type override from tokenizer
  displayType;

  constructor() {}

  ngOnInit() {
    this.updateDisplayType();
  }

  ngOnChanges() {
    this.updateDisplayType();
  }

  private updateDisplayType() {
    // Use provided type if available, otherwise detect from number
    if (this.type) {
      this.displayType = this.normalizeCardType(this.type);
    } else if (this.number) {
      this.displayType = CreditCard.cardType(this.number);
    }
  }

  private normalizeCardType(type: string): string {
    // Normalize tokenizer card types to match our display logic
    const normalized = type.toLowerCase();
    switch (normalized) {
      case 'visa':
        return 'visa';
      case 'mastercard':
      case 'master':
        return 'mastercard';
      case 'amex':
      case 'american_express':
      case 'americanexpress':
        return 'amex';
      case 'discover':
        return 'discover';
      case 'diners':
      case 'dinersclub':
      case 'diners_club':
        return 'diners';
      case 'jcb':
        return 'jcb';
      default:
        return null; // Show all indicators when type is unknown
    }
  }
}
